export const FESTIVAL_FULL_NAME = '2025 목포해상W쇼 Mokpo Marine W Show';

export const FACEBOOK_URL = 'https://www.facebook.com/wshowmokpo/';
export const INSTAGRAM_URL = 'https://www.instagram.com/mokpowshow/';
export const YOUTUBE_URL =
  'https://www.youtube.com/@%EB%AA%A9%ED%8F%AC%ED%95%B4%EC%83%81W%EC%87%BC';

// 센터 전화번호
export const CENTER_PHONE = '061-244-8729';
